import { useEffect, useRef } from "react";
import type { Section } from "../../features/questionnaire";

export const useSectionNavigation = (
  currentSectionIndex: number,
  setCurrentSectionIndex: (index: number) => void,
  sections: Section[] = [],
) => {
  const SECTION_KEY = "section";
  const initialized = useRef(false);

  // Sync URL to match state (state is always the source of truth)
  useEffect(() => {
    if (!sections.length) return;

    const params = new URLSearchParams(window.location.search);

    if (!initialized.current) {
      params.set(SECTION_KEY, currentSectionIndex.toString());
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}?${params}`,
      );
      initialized.current = true;
    } else {
      const urlSection = parseInt(params.get(SECTION_KEY) ?? "", 10);
      if (urlSection !== currentSectionIndex) {
        params.set(SECTION_KEY, currentSectionIndex.toString());
        window.history.pushState(
          null,
          "",
          `${window.location.pathname}?${params}`,
        );
      }
    }
  }, [sections.length, currentSectionIndex]);

  // Back/forward: only time URL drives state
  useEffect(() => {
    const onPopState = () => {
      const section = parseInt(
        new URLSearchParams(window.location.search).get(SECTION_KEY) ?? "",
        10,
      );
      if (
        !isNaN(section) &&
        section >= 0 &&
        section < sections.length &&
        section !== currentSectionIndex
      ) {
        setCurrentSectionIndex(section);
      }
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [currentSectionIndex, setCurrentSectionIndex, sections.length]);
};
